import {
  GET_ALL_SCRUTINY_NOTES,
  GET_ALL_SCRUTINY_NOTES_ERROR,
  GET_ALL_SCRUTINY_NOTES_SUCCESS,
  GET_ALL_SCRUTINY_NOTES_TYPE,
  GET_ALL_SCRUTINY_NOTES_TYPE_ERROR,
  GET_ALL_SCRUTINY_NOTES_TYPE_SUCCESS,
} from "./actionType"

const initialState = {}

const scrutinynote = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_SCRUTINY_NOTES:
      state = {
        ...state,
        getallscrutinynotesSuccess: action.payload,
        getallscrutinynotesError: null,
      }
      break

    case GET_ALL_SCRUTINY_NOTES_SUCCESS:
      state = {
        ...state,
        getallscrutinynotesSuccess: action.payload,
        getallscrutinynotesError: null,
      }
      break

    case GET_ALL_SCRUTINY_NOTES_ERROR:
      state = { ...state, getallscrutinynotesError: action.payload }
      break
    // start scrutiny type
    case GET_ALL_SCRUTINY_NOTES_TYPE:
      state = {
        ...state,
        getallscrutinynotestypeSuccess: action.payload,
        getallscrutinynotestypeError: null,
      }
      break

    case GET_ALL_SCRUTINY_NOTES_TYPE_SUCCESS:
      state = {
        ...state,
        getallscrutinynotestypeSuccess: action.payload,
        getallscrutinynotestypeError: null,
      }
      break

    case GET_ALL_SCRUTINY_NOTES_TYPE_ERROR:
      state = { ...state, getallscrutinynotestypeError: action.payload }
      break
    // end scrutiny type
    default:
      state = { ...state }
      break
  }
  return state
}

export default scrutinynote
